import { UTCStringToDateTime } from '@shared/utils/dates/DateParsing.util';
import { Console } from 'console';
import { hasValue } from '../helpers';

export function dateInPast(firstDate, secondDate): boolean {

  const firstDateParsed = UTCStringToDateTime(firstDate);
  const secondDateParsed = UTCStringToDateTime(secondDate);

  return firstDateParsed.setHours(0, 0, 0, 0) <= secondDateParsed.setHours(0, 0, 0, 0);
}

/**
 * Obtains the elapsed time between two time objects in javscript in the format of: "00 : 00 : 00"
 * @param from Date
 * @param to Date
 * @returns string in format "00 : 00 : 00"
 */
export function getElapsedTime(from: Date, to: Date): string {
  if (!hasValue(from) || !hasValue(to)) {
    return null;
  }

  // get total seconds between the times
  let delta = Math.abs(from.getTime() - to.getTime()) / 1000;

  const days = Math.floor(delta / 86400);
  delta -= days * 86400;

  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;

  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;

  const seconds = Math.floor((delta % 60));
  const pad = (num) => {
    let str = '' + num;
    if (str.length === 1) {
      str = '0' + str;
    }
    return str;
  };

  // check if hours exist in time
  if(hours.toString() !== "0"){
    return `${pad(hours)} : ${pad(minutes)} : ${pad(seconds)}`;
  }
  return `${pad(minutes)} : ${pad(seconds)}`;
}
